import { useContext, useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ToastContext from "../../../../contexts/toast.js";
import { RichiestaService } from "../../../../services/RichiestaService.js";
import Input from "../../../Form/Input.js";
import { FormUtility } from "../../../Utility/FormUtility.js";
import AlertMessage from "../../../Utility/Alert/AlertMessage.js";
import Checkbox from "../../../Form/Checkbox.js";
import Radio from "../../../Form/Radio.js";
import Select from "../../../Form/Select.js";
import InputIban from "../../../Form/InputIban.js";
import StatusContext from "../../../../contexts/status.js";
import { DatiUtenza } from "../../../../models/DatiUtenza.js";
import Modal from "../../../Utility/Modal/Modal.js";
import { NazioneService } from "../../../../services/NazioneService.js";
import tuttiComuni from "../../../Utility/json/tuttiComuni.js";
import { PlessoService } from "../../../../services/PlessoService.js";
import moment from 'moment';
import { FaseService } from "../../../../services/FaseService.js";
import DatePicker from "../../../Form/DatePicker.js";
import protocolloDsu from "../../../../assets/img/protocolloDsu.png";
import { IMaskInput } from "react-imask";

const RettificaRipresentazione = (props) => {
  const scrollRef = useRef(null);
    const formRef = useRef(null);
    const [dirty, setDirty] = useState(false);
    const toastContext = useContext(ToastContext);
    const { id } = useParams();
    const [showError, setShowError] = useState(false);
    const [inSave, setInSave] = useState(false);
    const [inputErrors, setInputErrors] = useState([]);
    const [loading, setLoading] = useState(true);
    const [richiesta, setRichiesta] = useState({});
    const [richiestaOriginale, setRichiestaOriginale] = useState({});
    const [richiestaDatiBeneficiario, setRichiestaDatiBeneficiario] = useState(
        new DatiUtenza()
    );
    const [richiestaIscrizioneScolastica, setRichiestaIscrizioneScolastica] = useState({});
    const [richiestaDatiPagamento, setRichiestaDatiPagamento] = useState({});
    const [validate, setValidate] = useState(false);
    const statusContext = useContext(StatusContext);
    const [informativa1, setInformativa1] = useState(false);
    const [informativa2, setInformativa2] = useState(false);
    const [informativa3, setInformativa3] = useState(false);

    const [isModalOpen, setModalOpen] = useState(false);
    const [title, setTitle] = useState(null);
    const [content, setContent] = useState(null);
    const [icon, setIcon] = useState(false);
    const [hideCloseButton, setHideCloseButton] = useState(false);
    const [actionLabel, setActionLabel] = useState(false);
    const navigate = useNavigate();
    const [iconaClass, setIconaClass] = useState(null);
    const [iconaColorClass, setIconaColorClass] = useState(null);
    const [saveDone, setSaveDone] = useState(false);


    /*nuovi*/
    const [dsu, setDsu] = useState("");
    const [errorDsu, setErrorDsu] = useState(false);
    const dsuInputRef = useRef(null);
    const [firstTime, setFirsTime] = useState(true);
    const [startUp, setStartup] = useState(true);
    const [etaMillesimo, setEtaMillesimo] = useState(null);



    const [condizioniStudente, setCondizioniStudente] = useState([
        { key: 'AMMESSO', value: 'Ammesso alla classe successiva' },
        { key: 'NON_AMMESSO', value: 'Non ammesso alla classe successiva' }        
    ]);
    const ordini = [
        { key: 'MEDIA', value: "Scuola secondaria di primo grado (scuola media)" },
        { key: 'SUPERIORE', value: "Scuola secondaria di secondo grado (scuola superiore)" }
    ];
    const [cittadinanze, setCittadinanze] = useState(null);
    const [anniCorso, setAnniCorso] = useState([]);
    const regioni = [
        { key: 'Emilia-Romagna', value: 'Emilia Romagna' },
        { key: 'Lazio', value: 'Lazio' },
        { key: 'Liguria', value: 'Liguria' },
        { key: 'Marche', value: 'Marche' },
        { key: 'Umbria', value: 'Umbria' }
    ];
    const [comuni, setComuni] = useState([]);
    const [comuniScuola, setComuniScuola] = useState([]);
    const [plessi, setPlessi] = useState([]);
    const [indirizziDiStudio, setIndirizziDiStudio] = useState([]);

    const [errorIban, setErrorIban] = useState(false);

    const [loadingPlessi, setLoadingPlessi] = useState(false);

    const [fase, setFase] = useState(null);

    const map = {
        informativa1: setInformativa1,
        informativa2: setInformativa2
        ,informativa3: setInformativa3
    };

    const richiestaService = new RichiestaService();
    const nazioneService = new NazioneService();
    const plessoService = new PlessoService();
    const faseService = new FaseService();

    const utility = new FormUtility();

    useEffect(() => {
        nazioneService.getAll().then(resp => {
            let nations = [...resp];
            const italia = nations.find((nazione) => nazione.nome === "Italia");
            nations.sort((a, b) => (a.cittadinanza.localeCompare(b.cittadinanza)));
            nations = nations.filter((nazione) => nazione.nome !== "Italia");
            nations.unshift(italia);
            setCittadinanze([...nations]);
        });

        const comuniScuola = [...tuttiComuni]
            .filter(el => el.denominazione_regione === 'Toscana' && el.data_fine_validita === null)
            .sort((a, b) => a.denominazione.localeCompare(b.denominazione));
        setComuniScuola(comuniScuola);

        return () => {
            statusContext.removeEvent("onbeforeunload");
            setDirty(false);
        }
    }, []);

    useEffect(() => {
        if (!id) return;

        const fetchRichiesta = async () => {
            try {
                const resp = await richiestaService.get(id);
                setRichiestaOriginale({ ...resp });
                setRichiesta({ ...resp });
                setRichiestaDatiBeneficiario({ ...resp.richiestaDatiBeneficiario });
                setRichiestaDatiPagamento({ ...resp.richiestaDatiPagamento });
                setRichiestaIscrizioneScolastica({ ...resp.richiestaIscrizioneScolastica });
                onChangeOrdineGrado(
                    { target: { value: resp.richiestaIscrizioneScolastica.ordineGrado } },
                    resp,
                    resp.richiestaIscrizioneScolastica,
                    false
                );

                const fase = await faseService.getFaseByTipologiaAndPresentazioneDomandaId('AGGIORNAMENTO_ISEE', resp.fase.id);
                console.log('fase',fase);
                setFase(fase);

                if (resp.richiestaIscrizioneScolastica.regioneScuolaFuoriToscana) {
                    onChangeRegione(
                        { target: { value: resp.richiestaIscrizioneScolastica.regioneScuolaFuoriToscana } },
                        false
                    );
                }

                setCondizioniStudente([
                    { key: 'AMMESSO', value: "Ammesso alla classe successiva" },
                    { key: 'NON_AMMESSO', value: "Non ammesso alla classe successiva" }                    
                ]);
                if (resp?.richiestaDatiPagamento?.dsu) {
                    setDsu(resp?.richiestaDatiPagamento?.dsu);
                    handleDsuChange(resp?.richiestaDatiPagamento?.dsu.substring(15), false); 
                }


            } catch (error) {
                console.error('Errore durante il fetch della richiesta:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchRichiesta();
    }, [id]);

    const onChangeValueCheckBox = (event) => {
        const target = event.target;
        const set = map[target.name];
        set(target.checked === true);
        onModifiedData(validate,false);
    };

    const setFormErrors = (setFocus = true) => {
        const errors = utility.getAllInputErrors(formRef);
        setInputErrors(errors.map((el) => el.id));
        if (setFocus && errors.length > 0) {
            errors[0].focus();
        }
    };

    const onModifiedData = (updateFormErrors = true, updateDirty = true) => {
        console.log("onModifiedData",updateFormErrors,updateDirty);
        if (updateFormErrors) {
            setTimeout(() => {
                setFormErrors(false);
            }, 0);
        }

        if (updateDirty) {
            statusContext.addEvent("onbeforeunload");
            setDirty(true);
        }
    };

    const onChangeRadioButtonValue = (checked, field) => {
        switch (field) {
            case "modificaDatiIscrizioneScolastica":
                setRichiestaIscrizioneScolastica({
                    ...richiestaOriginale.richiestaIscrizioneScolastica,
                    [field]: checked,
                    condizioneStudente: richiestaIscrizioneScolastica.condizioneStudente,
                    inserimentoDatiIscrizioneSecondoAccesso: null,
                    istitutoInToscana: null,
                    cambioIstitutoTipologia: null
                });
                break;
            case "modificaDatiPagamento":
                setRichiestaDatiPagamento({
                    ...richiestaOriginale.richiestaDatiPagamento,
                    [field]: checked
                });
                setRichiestaDatiBeneficiario({
                    ...richiestaOriginale.richiestaDatiBeneficiario
                });
                break;
            case "inserimentoDatiIscrizioneSecondoAccesso":
                setRichiestaIscrizioneScolastica({
                    ...richiestaOriginale.richiestaIscrizioneScolastica,
                    [field]: checked,
                    condizioneStudente: richiestaIscrizioneScolastica.condizioneStudente,
                    cambioIstitutoTipologia: richiestaIscrizioneScolastica.cambioIstitutoTipologia,
                    modificaDatiIscrizioneScolastica: false
                });
                break;
            case "cambioIstitutoTipologia":
                setRichiestaIscrizioneScolastica({
                    ...richiestaOriginale.richiestaIscrizioneScolastica,
                    [field]: checked,
                    condizioneStudente: richiestaIscrizioneScolastica.condizioneStudente,
                    inserimentoDatiIscrizioneSecondoAccesso: null
                });
                break;
            case 'istitutoInToscana':
                setRichiestaIscrizioneScolastica({
                    ...richiestaOriginale.richiestaIscrizioneScolastica,
                    [field]: checked,
                    condizioneStudente: richiestaIscrizioneScolastica.condizioneStudente,
                    modificaDatiIscrizioneScolastica: richiestaIscrizioneScolastica.modificaDatiIscrizioneScolastica,
                    cambioIstitutoTipologia: richiestaIscrizioneScolastica.cambioIstitutoTipologia,
                    ordineGrado: richiestaIscrizioneScolastica.ordineGrado,
                    annoCorso: richiestaIscrizioneScolastica.annoCorso,
                    inserimentoDatiIscrizioneSecondoAccesso: richiestaIscrizioneScolastica.inserimentoDatiIscrizioneSecondoAccesso,
                });
                break;
            default:
                break;
        }
        onModifiedData(validate);
    }

    const onChangeOrdineGrado = async (event, richiesta, richiestaIscrizioneScolastica, updateDirty = true) => {
        const value = event.target.value;
        richiestaIscrizioneScolastica.ordineGrado = value;
        if (!richiestaIscrizioneScolastica.ordineGrado) {
            richiestaIscrizioneScolastica.annoCorso = null;
            richiestaIscrizioneScolastica.comune = null;
            richiestaIscrizioneScolastica.plesso = null;
            richiestaIscrizioneScolastica.scuola = null;
            richiestaIscrizioneScolastica.indirizzoDiStudio = null;
            richiestaIscrizioneScolastica.comuneFuoriToscanaId = null;
            richiestaIscrizioneScolastica.scuolaFuoriToscana = null;
            richiestaIscrizioneScolastica.codiceScuolaFuoriToscana = null;
            setRichiestaIscrizioneScolastica({ ...richiestaIscrizioneScolastica });
            onModifiedData(validate, updateDirty);
            return;
        }

        if (updateDirty) {
            setRichiestaIscrizioneScolastica({
                ...richiestaIscrizioneScolastica,
                comune: null,
                plesso: null,
                scuola: null,
                indirizzoDiStudio: null,
                comuneFuoriToscanaId: null,
                scuolaFuoriToscana: null,
                codiceScuolaFuoriToscana: null,
            });
        }

        const options =
            value === 'MEDIA'
                ? [
                    { key: 1, label: "1° anno" },
                    { key: 2, label: "2° anno" },
                    { key: 3, label: "3° anno" },
                ]
                : [
                    { key: 1, label: "1° anno" },
                    { key: 2, label: "2° anno" },
                    { key: 3, label: "3° anno" },
                    { key: 4, label: "4° anno" },
                    { key: 5, label: "5° anno" },
                    { key: 6, label: "6° anno" },
                ];

        setAnniCorso(options);

        const comune = [...tuttiComuni].find(c => c.id === parseInt(richiestaIscrizioneScolastica?.comune?.id || richiestaIscrizioneScolastica?.comune));
        let plexes;
        if (comune) {
            plexes = await getPlessiByBandoIdAndComuneId(richiesta, richiestaIscrizioneScolastica, comune.id, comune.denominazione);
        }
        if (!updateDirty && (richiestaIscrizioneScolastica.plesso?.id || richiestaIscrizioneScolastica.scuola)) {
            onChangeScuola(
                { target: { value: richiestaIscrizioneScolastica.plesso?.id ?? richiestaIscrizioneScolastica.scuola } },
                richiestaIscrizioneScolastica,
                plexes,
                updateDirty
            );
        }
        onModifiedData(validate, updateDirty);
    };

    useEffect(() => {
        scrollRef?.current?.scrollIntoView({
            behavior: "smooth",
            block: "start",
        });        
    }, [richiesta]);

    const onChangeValue = async (event, field = "value", targetName = null) => {
        const target = event.target;
        const name = targetName ?? target.name;
        const value = target[field];

        if (name === 'condizioneStudente') {
            
            setRichiestaIscrizioneScolastica({
                ...richiestaOriginale.richiestaIscrizioneScolastica,
                [name]: value,
                istitutoInToscana: null,
                cambioIstitutoTipologia: null,
                scuolaFuoriToscana: null,
                codiceScuolaFuoriToscana: null,
                denominazioneScuolaFuoriToscana: null,
                comune: null,
                comuneFuoriToscanaId: null,
                indirizzoScuolaFuoriToscana: null,
                scuola: null,
                plesso: null,
                ordineGrado:null,
                annoCorso:null,
                confermaComunicazioneAssegnazione:null

            });            
        } else if (name === "nome" || name === "cognome" || name === "cittadinanza") {
            richiestaDatiBeneficiario[name] = value;
            setRichiestaDatiBeneficiario({ ...richiestaDatiBeneficiario });
        } else if (
            name === 'scuolaFuoriToscana' ||
            name === 'codiceScuolaFuoriToscana' ||
            name === 'denominazioneScuolaFuoriToscana' ||
            name === 'comune' ||
            name === 'comuneFuoriToscanaId' ||
            name === 'annoCorso' ||
            name === 'indirizzoDiStudio' ||
            name === 'indirizzoScuolaFuoriToscana'
        ) {
            richiestaIscrizioneScolastica[name] = value;
            setRichiestaIscrizioneScolastica({ ...richiestaIscrizioneScolastica });
        } else if (name === 'denominazioneBanca') {
            richiestaDatiPagamento[name] = value;
            setRichiestaDatiPagamento({ ...richiestaDatiPagamento });
        }
        onModifiedData(validate);
    };

    const onChangeRegione = (event, toUpdate = true) => {
        const target = event.target;
        const value = target.value;

        if (toUpdate) {
            richiestaIscrizioneScolastica.regioneScuolaFuoriToscana = value;
            setRichiestaIscrizioneScolastica({ ...richiestaIscrizioneScolastica });
        }

        const comuni = [...tuttiComuni].filter(el => el.denominazione_regione === value);
        setComuni([...comuni]);
        onModifiedData(validate, toUpdate);
    }

    const onChangeComuneScuola = (event, field) => {
        const target = event.target;
        const value = target.value;

        richiestaIscrizioneScolastica[field] = value;
        setRichiestaIscrizioneScolastica({ ...richiestaIscrizioneScolastica });

        const comune = comuniScuola.find(c => c.id === parseInt(value));
        if (comune) {
            getPlessiByBandoIdAndComuneId(richiesta, richiestaIscrizioneScolastica, comune.id, comune.denominazione);
        }

        setIndirizziDiStudio([]);
        onModifiedData(validate);
    }

    const getPlessiByBandoIdAndComuneId = async (richiesta, richiestaIscrizioneScolastica, comuneId, comuneDenominazione) => {
        setLoadingPlessi(true);

        let resp = await plessoService.getAllByBandoIdAndComuneId(richiesta.bando.id, comuneId);
        const isSuperiore = richiestaIscrizioneScolastica.ordineGrado === 'SUPERIORE';
        resp = resp?.filter((plesso) =>
            isSuperiore
                ? plesso.indirizzi.length > 0
                : plesso.indirizzi.length === 0
        )
            .map((el) => ({ ...el, label: `${el.denominazione} [${el.codice}]` }))
            .sort((a, b) => (a?.denominazione > b?.denominazione ? 1 : -1));

        setPlessi(resp);
        setLoadingPlessi(false);

        if (resp.length === 0) {
            toastContext.warning(`Non sono presenti scuole di ${richiestaIscrizioneScolastica.ordineGrado === 'SUPERIORE' ? "Secondo" : "Primo"}  grado nel comune di ${comuneDenominazione}`);
        }

        return resp;
    }

    const onChangeScuola = (event, richiestaIscrizioneScolastica, plessi, updateDirty = true) => {
        const target = event.target;
        const value = target.value;

        richiestaIscrizioneScolastica.scuola = value;
        setRichiestaIscrizioneScolastica({ ...richiestaIscrizioneScolastica });

        setIndirizziDiStudio(plessi.find(p => p.id === parseInt(value))?.indirizzi || []);
        onModifiedData(validate, updateDirty);
    }

    const validazioneIBANItaliano = (event, updateDirty = true) => {
        if (updateDirty) {
            setDirty(true);
        }

        setErrorIban(false);
        const iban = event.target.value.replace(/\s/g, '').toUpperCase();
        setRichiestaDatiPagamento({ ...richiestaDatiPagamento, iban: iban });
        const lunghezza = iban.length;
        const codicePaese = iban.substring(0, 2);

        if (codicePaese !== "IT") {
            setErrorIban(true);
            return false;
        }

        if (lunghezza !== 27) {
            setErrorIban(true);
            return false;
        }

        const cifreControllo = iban.substring(2, 4);
        const contoBase = iban.substring(4);
        let numeroRiorganizzato = contoBase + codicePaese + cifreControllo;
        numeroRiorganizzato = numeroRiorganizzato.replace(/[A-Z]/g, (lettera) => {
            return parseInt(lettera, 36);
        });

        let resto = numeroRiorganizzato;
        let blocco;
        while (resto.length > 2) {
            blocco = resto.substring(0, Math.min(9, resto.length));
            resto = parseInt(blocco, 10) % 97 + resto.substring(blocco.length);
        }
        const isValid = parseInt(resto, 10) % 97 === 1;
        setErrorIban(!isValid);

        return isValid;
    }



    const presentaDomanda = (event) => {
        
        console.log("rettifica domanda");
        event.preventDefault();
        event.stopPropagation();

        setValidate(true);

        const validity = formRef.current.checkValidity();

        if (!validity) {
            setFormErrors();
            return;
        }

        validazioneIBANItaliano({ target: { value: richiestaDatiPagamento.iban } }, false);
        if (errorIban) {
            setFormErrors();
            setShowError(true);
            return;
        }
        

        setModalOpen(true);
        setIcon(true);
        setActionLabel("Conferma");
        setTitle("Attenzione");
        setIconaClass("solid--exclamation-triangle");
        setIconaColorClass("rtds-text-warn-dark");
        setHideCloseButton(false);
        if (dirty) {
            setContent("Attenzione! Proseguire con l'aggiornamento della domanda?");
        } else {
            setContent(
                "Attenzione! Non è stato modificato alcun dato, proseguire con l'aggiornamento della domanda?"
            );
        }
        return;
    };

    const handleModalAction = async () => {
        console.log("handleModalAction");
        if (!saveDone) {
            setInSave(true);

            setInputErrors([]);
            const dsuString =utility.getINPS_ISEE_CurrentYear() + dsu;
            const body = {
                condizioneStudente: richiestaIscrizioneScolastica.condizioneStudente,
                modificaDatiIscrizioneScolastica: richiestaIscrizioneScolastica.modificaDatiIscrizioneScolastica,
                cambioIstitutoTipologia: richiestaIscrizioneScolastica.cambioIstitutoTipologia,
                nomeStudente: richiestaDatiBeneficiario.nome,
                cognomeStudente: richiestaDatiBeneficiario.cognome,
                codiceFiscaleStudente: richiestaDatiBeneficiario.codiceFiscale,
                dataNascita:richiestaDatiBeneficiario.dataNascita,
                eta:richiestaDatiBeneficiario.eta,
                iban: richiestaDatiPagamento.iban,
                denominazioneBanca: richiestaDatiPagamento.denominazioneBanca,
                ordineGrado: richiestaIscrizioneScolastica.ordineGrado,
                annoCorso: richiestaIscrizioneScolastica.annoCorso,
                istitutoInToscana: richiestaIscrizioneScolastica.istitutoInToscana,
                comune: comuni.find(c => c.id === parseInt(
                    richiestaIscrizioneScolastica.istitutoInToscana === false
                        ? richiestaIscrizioneScolastica.comuneFuoriToscanaId
                        : richiestaIscrizioneScolastica.comune?.id || richiestaIscrizioneScolastica.comune
                )),
                scuola: plessi.find(p => p.id === parseInt(richiestaIscrizioneScolastica.scuola || richiestaIscrizioneScolastica.plesso?.id)),
                indirizzoDiStudio: indirizziDiStudio.find(iid => iid.id === parseInt(richiestaIscrizioneScolastica.indirizzoDiStudio?.id || richiestaIscrizioneScolastica.indirizzoDiStudio)),
                regioneScuolaFuoriToscana: !richiestaIscrizioneScolastica.istitutoInToscana ? richiestaIscrizioneScolastica.regioneScuolaFuoriToscana : null,
                codiceScuolaFuoriToscana: !richiestaIscrizioneScolastica.istitutoInToscana ? richiestaIscrizioneScolastica.codiceScuolaFuoriToscana : null,
                denominazioneScuolaFuoriToscana: !richiestaIscrizioneScolastica.istitutoInToscana ? richiestaIscrizioneScolastica.denominazioneScuolaFuoriToscana : null,
                indirizzoScuolaFuoriToscana:!richiestaIscrizioneScolastica.istitutoInToscana ? richiestaIscrizioneScolastica.indirizzoScuolaFuoriToscana : null
                ,dsu:dsuString
                ,confermaComunicazioneAssegnazione:richiestaIscrizioneScolastica.confermaComunicazioneAssegnazione
            };

            richiestaService
                .rettificaDomandaRipresentazione(id, body)
                .then((result) => {
                    setRichiesta(result);
                    setHideCloseButton(true);
                    const msg = "Dati aggiornati con successo";
                    toastContext.success(msg);
                    statusContext.removeEvent("onbeforeunload");

                    setDirty(false);
                    setActionLabel("Chiudi");
                    setTitle("Domanda aggiornata!");
                    setIcon(true);
                    setIconaClass("solid--check-circle");
                    setIconaColorClass("rtds-text-success-dark");
                    setContent(
                        `La domanda con codice '${richiesta.codice}'. è stata aggiornata correttamente. A seguito dei controlli verrà inviata un’e-mail di conferma dell'aggiornamento.`
                    );
                    setModalOpen(true);
                    setSaveDone(true);
                })
                .catch((err) => {
                    toastContext.error(utility.getErrorMsg(err), 2500);
                    setInSave(false);
                    setModalOpen(false);
                });
        } else {
            navigate("/dashboard");
        }
    };


    const inpsIseeCurrentYear = utility.getINPS_ISEE_CurrentYear();

    function validaDsu(dsu) {
        setErrorDsu(false);
        const regex = /^\d{8}[A-Za-z]-\d{2}$/;
        const ok = regex.test(dsu);
        setErrorDsu(!ok);
        return ok;
    }

    const handleDsuChange = (value, updateDirty = true) => {
        console.log(value, firstTime, startUp);
        if (!firstTime && updateDirty && !startUp) {
            setDirty(true);
        }
        if (value?.length > 8) {
            value = value.substring(0, 8) + value.substring(8, 9).toUpperCase() + value.substring(9);
        }

        const isValid = validaDsu(value);
        setErrorDsu(!isValid);
        setFirsTime(false);
        setDsu(value);
        onModifiedData(validate,updateDirty);


    };

    const onChangeCodiceFiscale = (event) => {
        const value = event.target.value;

        calculateFiscalCodeData(richiestaDatiBeneficiario, value, richiesta.dataPresentazione);

        onModifiedData(validate);
        setDirty(true);
    };

    const calculateFiscalCodeData = (richiestaDatiBeneficiario, value, dataPresentazione) => {
        if (value.length === 16) {
            richiestaDatiBeneficiario.eta = utility.ottieniEtaDaCodiceFiscaleRettifica(
                value.toUpperCase(), new Date(dataPresentazione?.replace(' ', 'T'))
            );
            richiestaDatiBeneficiario.dataNascita = moment(
                utility.ottieniDataNascitaDaCodiceFiscale(value.toUpperCase())
            ).format("YYYY-MM-DD");
            setEtaMillesimo(
                utility.ottieniEtaMillesimoDaCodiceFiscaleRettifica(
                    value.toUpperCase(),
                    new Date(dataPresentazione?.replace(' ', 'T'))
                )
            );
        } else {
            richiestaDatiBeneficiario.eta = null;
            richiestaDatiBeneficiario.dataNascita = null;
        }

        richiestaDatiBeneficiario.codiceFiscale = value;

        setRichiestaDatiBeneficiario({ ...richiestaDatiBeneficiario });
    }

    const getInfoCondizioneStudente = (condizione) => {
        return 'Confermo che lo studente è iscritto a una scuola secondaria di primo grado (scuola media) o secondo grado (scuola superiore) e mi impegno a comunicare al prossimo accesso classe/istituto/scuola a cui è iscritto per l\'a.s. ' + richiesta?.bando?.annoEducativo + ', secondo la procedura esposta nell\'Avviso Libri Gratis';
    }

    const onChangeConfermaAssegnazione = (value) => {

        if (value === null) return;
        setDirty(true);
        setRichiestaIscrizioneScolastica({ ...richiestaIscrizioneScolastica, confermaComunicazioneAssegnazione: value });
        onModifiedData(validate);
    }

    return (
        <>
            {/* Inizio Loading */}
            <section className="rtds-grid rtds-gap-4" hidden={!loading}>
                <div
                    className="rtds-empty-state rtds-grid rtds-gap-4"
                    aria-live="assertive"
                    aria-atomic="true"
                >
                    <div className="rtds-font-bold rtds-text-center rtds-grid rtds-gap-8 rtds-justify-center rtds-justify-items-center rtds-py-20">
                        <svg
                            className="rtds-icon rtds-fill-current rtds-w-16 rtds-h-16 rtds-animate-spin"
                            aria-hidden="true"
                            focusable="false"
                            role="img"
                        >
                            <use xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#spinner`} />
                        </svg>
                        <span className="rtds-sr-only">Caricamento...</span>

                        <h3 className="rtds-heading-4">
                            <div className="loading-message">
                                Attendere un momento
                                <span className="dots">...</span>
                            </div>
                        </h3>
                    </div>
                </div>
            </section>
            {/* Fine Loading */}

            <div
                className="rtds-container rtds-my-12"
                hidden={loading}
                ref={scrollRef}
            >
                <div
                    key={5}
                    //hidden={false}
                    id={`tabpanel-5`}
                    className="rtds-tablist__tabpanel"
                    role="tabpanel"
                    aria-labelledby={`tab-5`}
                >
                    <div className=" rtds-my-12 ">
                        <div className="rtds-mb-6">
                            <h1 className="rtds-text-2xl rtds-font-bold">
                                {`Dati da aggiornare per la domanda ${richiesta.codice || ""}`}
                            </h1>
                        </div>
                        <div className="rtds-background-01 rtds-p-6 rtds-border rtds-border-gray-02">
                            <AlertMessage
                                message={`Compila attentamente questa sezione inserendo i dati corretti per poter proseguire con l’iter del bando.`}
                                iconName="mini--information-circle"
                                title="Attenzione!"
                                classArticle="rtds-mb-6"
                            />

                            <div className="rtds-pb-6 rtds-space-y-4 rtds-border-b rtds-border-gray-02">
                                <p>
                                    I campi obbligatori sono contrassegnati da un asterisco&nbsp;
                                    <abbr
                                        className="rtds-font-bold rtds-no-underline"
                                        title="obbligatorio"
                                    >
                                        *
                                    </abbr>
                                </p>
                            </div>

                            <form
                                noValidate
                                ref={formRef}
                                id="hasValidationFor"
                                className="has-js-validation-form rtds-py-6 rtds-space-y-4"
                            >


                                <div>
                                    <h2 className="rtds-text-xl rtds-font-bold">
                                        Dati identificativi dello studente
                                    </h2>
                                    <div className="rtds-field-row">
                                        <Input
                                            label={"Codice Fiscale dello studente"}
                                            id={"codiceFiscaleBeneficiario"}
                                            classInput={
                                                "rtds-text-sm rtds-input-placeholder rtds-uppercase"
                                            }
                                            type={"text"}
                                            pattern={utility.regExprFiscalCode}
                                            onChange={(event) => onChangeCodiceFiscale(event)}
                                            value={richiestaDatiBeneficiario?.codiceFiscale || ""}

                                            maxLength={16}
                                            minLength={16}
                                            inputErrors={inputErrors}
                                            errorMessage={utility.checkFiscalCodeValidity(
                                                validate,
                                                richiestaDatiBeneficiario?.codiceFiscale,
                                                utility.regExprFiscalCode
                                            )}
                                            required
                                            disabled={!richiesta?.hasErroreIseeCfNonPresente}
                                        />

                                        <Input
                                            classDiv={"rtds-mt-3 lg:rtds-mt-0"}
                                            label={"Nome dello Studente"}
                                            id={"nomeBeneficiario"}
                                            classInput={
                                                "rtds-text-sm rtds-input-placeholder rtds-pr-12"
                                            }
                                            type={"text"}
                                            onChange={(event) => onChangeValue(event, "value", "nome")}
                                            value={richiestaDatiBeneficiario?.nome || ""}

                                            inputErrors={inputErrors}
                                            required
                                            maxLength={50}
                                        />

                                        <Input
                                            classDiv={"rtds-mt-3 lg:rtds-mt-0"}
                                            label={"Cognome dello Studente"}
                                            id={"cognomeBeneficiario"}
                                            classInput={"rtds-text-sm rtds-input-placeholder"}
                                            type={"text"}
                                            onChange={(event) => onChangeValue(event, "value", "cognome")}
                                            value={richiestaDatiBeneficiario?.cognome || ""}

                                            inputErrors={inputErrors}
                                            required
                                            maxLength={50}
                                        />
                                    </div>

                                    <div className="rtds-horizontal-divider rtds-border-b rtds-border-gray-03 rtds-mt-3 rtds-mb-4 "></div>

                                    <h2 className="rtds-text-xl rtds-font-bold">
                                        Età dello studente
                                    </h2>
                                    <AlertMessage
                                        message="La data di nascita e l'età vengono calcolate automaticamente in base al Codice Fiscale inserito."
                                        iconName="mini--information-circle"
                                        title="Nota Bene!"
                                        classArticle="rtds-mb-6"
                                    />

                                    <div className="rtds-field-row">
                                        <DatePicker
                                            label={"Data di Nascita dello Studente"}
                                            id={"dataNascita"}
                                            inputErrors={inputErrors}
                                            classInput={"rtds-text-sm rtds-input-placeholder"}
                                            type={"date"}
                                            defaultValue={richiestaDatiBeneficiario?.dataNascita || ""}
                                            readOnly
                                            hideSubTitle
                                        />

                                        <Input
                                            classDiv={"rtds-mt-3 lg:rtds-mt-0"}
                                            label={"Età dello Studente al momento della presentazione della domanda"}
                                            id={"eta"}
                                            classInput={"rtds-text-sm rtds-input-placeholder"}
                                            type={"text"}
                                            value={richiestaDatiBeneficiario?.eta || ""}
                                            readOnly
                                        />
                                    </div>

                                    <div className="rtds-horizontal-divider rtds-border-b rtds-border-gray-03 rtds-mt-3 rtds-mb-4 "></div>
                                    <h2 className="rtds-text-xl rtds-font-bold">
                                        Dichiarazioni ed esito
                                    </h2>

                                    <div className="rtds-field-row ">
                                        <Select
                                            classDiv={"rtds-mt-3 lg:rtds-mt-0"}
                                            label={
                                                "Condizione dello studente alla chiusura dell'A.S. " +
                                                utility.ottieniAnnoPrecedente(richiesta?.bando?.annoEducativo)
                                            }
                                            required
                                            id={"condizioneStudente"}
                                            inputErrors={inputErrors}
                                            classSelect={"rtds-overflow-hidden text-ellipsis rtds-whitespace-nowrap rtds-w-full rtds-pr-7"}
                                            onChange={(event) =>
                                                onChangeValue(event, "value", "condizioneStudente")
                                            }
                                            baseOption={"Seleziona Condizione"}
                                            options={condizioniStudente}
                                            bindKey={"key"}
                                            bindValue={"value"}
                                            value={
                                                richiestaIscrizioneScolastica.condizioneStudente || ""
                                            }
                                            aria-describedby="span_info_codizione"
                                        />
                                    </div>

                                    <div className="rtds-horizontal-divider rtds-border-b rtds-border-gray-03 rtds-mt-3 rtds-mb-4 "></div>

                                    <h2 className="rtds-text-xl rtds-font-bold">
                                        Informazioni sulla scuola che lo studente frequenterà nell'anno scolastico{" "}
                                        {richiesta?.bando?.annoEducativo}
                                    </h2>
                                    <AlertMessage
                                        message={
                                        "Compila attentamente questa sezione. Se indichi una classe di frequenza errata per l'A.S. " +
                                        richiesta?.bando?.annoEducativo +
                                        ", potresti ricevere un contributo inferiore e non avere diritto a chiedere la differenza in un secondo momento oppure potresti essere soggetto a revoca e successiva azione di recupero come stabilito dall'Avviso Libri Gratis."
                                    }
                                        iconName="mini--information-circle"
                                        title="Attenzione!"
                                        classArticle="rtds-mb-6"
                                    />

                                    {!(
                                        richiestaIscrizioneScolastica.condizioneStudente ===
                                        "SOSPENSIONE_DEL_GIUDIZIO" ||
                                        richiestaIscrizioneScolastica.condizioneStudente ===
                                        "MOBILITA_FORMATIVA" ||
                                        richiestaIscrizioneScolastica.condizioneStudente ===
                                        "STATO_PROVVISORIO"
                                    ) && (

                                            <div className="rtds-field-row">
                                                <Select
                                                    classDiv={"rtds-mt-3 lg:rtds-mt-0"}
                                                    label={"Ordine e grado"}
                                                    id={"ordineGrado"}
                                                    classSelect={""}
                                                    onChange={(event) =>
                                                        onChangeOrdineGrado(
                                                            event,
                                                            richiesta,
                                                            richiestaIscrizioneScolastica,
                                                        )
                                                    }
                                                    baseOption={"Nessuna selezione"}
                                                    options={ordini}
                                                    bindValue={"value"}
                                                    bindKey={"key"}
                                                    value={richiestaIscrizioneScolastica.ordineGrado || ""}
                                                    inputErrors={inputErrors}
                                                    required
                                                />

                                                <Select
                                                    classDiv={"rtds-mt-3 lg:rtds-mt-0"}
                                                    label={
                                                        "Anno di corso (classe a.s. " +
                                                        richiesta?.bando?.annoEducativo +
                                                        ")"
                                                    }
                                                    id={"annoCorso"}
                                                    classSelect={""}
                                                    onChange={(event) =>
                                                        onChangeValue(event, "value", "annoCorso")
                                                    }
                                                    baseOption={"Nessuna selezione"}
                                                    bindKey={"key"}
                                                    bindValue={"label"}
                                                    options={anniCorso}
                                                    disabled={!richiestaIscrizioneScolastica.ordineGrado}
                                                    value={richiestaIscrizioneScolastica.annoCorso || ""}
                                                    inputErrors={inputErrors}
                                                    required
                                                />
                                            </div>
                                        )}

                                    {!(
                                        richiestaIscrizioneScolastica.condizioneStudente ===
                                        "SOSPENSIONE_DEL_GIUDIZIO" ||
                                        richiestaIscrizioneScolastica.condizioneStudente ===
                                        "MOBILITA_FORMATIVA" ||
                                        richiestaIscrizioneScolastica.condizioneStudente ===
                                        "STATO_PROVVISORIO" ||
                                        richiestaIscrizioneScolastica.condizioneStudente ===
                                        "ATTESA_ASSEGNAZIONE"
                                    ) && (
                                            <div className="rtds-field-row">
                                                <div className="">
                                                    <fieldset className="rtds-input-field rtds-gap-2">
                                                        <legend className="rtds-input-field__label">
                                                            L'istituto scolastico ha sede in Toscana?&nbsp;
                                                            <abbr
                                                                className="rtds-font-bold rtds-no-underline"
                                                                title="obbligatorio"
                                                            >
                                                                *
                                                            </abbr>
                                                        </legend>

                                                        <Radio
                                                            classDiv={"rtds-input-radio rtds-input--lg"}
                                                            label={"Sì"}
                                                            value="true"
                                                            id={"istitutoInToscanaSi"}
                                                            name="istitutoInToscana"
                                                            classInput={""}
                                                            onChange={() =>
                                                                onChangeRadioButtonValue(
                                                                    true,
                                                                    "istitutoInToscana",
                                                                )
                                                            }
                                                            checked={
                                                                richiestaIscrizioneScolastica.istitutoInToscana ===
                                                                true
                                                            }
                                                        ></Radio>
                                                        <Radio
                                                            classDiv={"rtds-input-radio rtds-input--lg"}
                                                            label={"No"}
                                                            value="false"
                                                            id={"istitutoInToscanaNo"}
                                                            name="istitutoInToscana"
                                                            classInput={""}
                                                            onChange={() =>
                                                                onChangeRadioButtonValue(
                                                                    false,
                                                                    "istitutoInToscana",
                                                                )
                                                            }
                                                            checked={
                                                                richiestaIscrizioneScolastica.istitutoInToscana ===
                                                                false
                                                            }
                                                            inputErrors={inputErrors}
                                                            required={
                                                                richiestaIscrizioneScolastica.istitutoInToscana ===
                                                                undefined ||
                                                                richiestaIscrizioneScolastica.istitutoInToscana ===
                                                                null
                                                            }
                                                        ></Radio>
                                                    </fieldset>
                                                </div>
                                            </div>
                                        )}
                                    {!(
                                        richiestaIscrizioneScolastica.condizioneStudente ===
                                        "SOSPENSIONE_DEL_GIUDIZIO" ||
                                        richiestaIscrizioneScolastica.condizioneStudente ===
                                        "MOBILITA_FORMATIVA" ||
                                        richiestaIscrizioneScolastica.condizioneStudente ===
                                        "STATO_PROVVISORIO" ||
                                        richiestaIscrizioneScolastica.condizioneStudente ===
                                        "ATTESA_ASSEGNAZIONE"
                                    ) &&
                                        richiestaIscrizioneScolastica.istitutoInToscana && (
                                            <>
                                                <div className="rtds-field-row">
                                                    <Select
                                                        classDiv={"rtds-mt-3 lg:rtds-mt-0"}
                                                        label={"Comune della scuola"}
                                                        id={"comune"}
                                                        classSelect={""}
                                                        onChange={(event) =>
                                                            onChangeComuneScuola(event, "comune")
                                                        }
                                                        baseOption={"Nessuna selezione"}
                                                        options={comuniScuola}
                                                        bindKey={"id"}
                                                        bindValue={"denominazione"}
                                                        value={
                                                            richiestaIscrizioneScolastica.comune?.id ||
                                                            richiestaIscrizioneScolastica.comune ||
                                                            ""
                                                        }
                                                        inputErrors={inputErrors}
                                                        disabled={
                                                            !richiestaIscrizioneScolastica.ordineGrado
                                                        }
                                                        required
                                                    />

                                                    <Select
                                                        classDiv={"rtds-mt-3 lg:rtds-mt-0"}
                                                        label={"Scuola"}
                                                        id={"scuola"}
                                                        classSelect={""}
                                                        onChange={(event) =>
                                                            onChangeScuola(
                                                                event,
                                                                richiestaIscrizioneScolastica,
                                                                plessi,
                                                            )
                                                        }
                                                        baseOption={"Nessuna selezione"}
                                                        bindKey={"id"}
                                                        bindValue={"label"}
                                                        options={plessi}
                                                        value={
                                                            richiestaIscrizioneScolastica?.scuola ||
                                                            richiestaIscrizioneScolastica.plesso?.id ||
                                                            ""
                                                        }
                                                        inputErrors={inputErrors}
                                                        required
                                                        disabled={
                                                            !richiestaIscrizioneScolastica.ordineGrado ||
                                                            !richiestaIscrizioneScolastica.comune ||
                                                            loadingPlessi
                                                        }
                                                    />

                                                    <Select
                                                        classDiv={"rtds-mt-3 lg:rtds-mt-0"}
                                                        label={"Indirizzo di studio"}
                                                        id={"indirizzoDiStudio"}
                                                        classSelect={""}
                                                        onChange={(event) =>
                                                            onChangeValue(event, "value", "indirizzoDiStudio")
                                                        }
                                                        baseOption={"Nessuna selezione"}
                                                        bindKey={"id"}
                                                        bindValue={"denominazione"}
                                                        options={indirizziDiStudio}
                                                        value={
                                                            richiestaIscrizioneScolastica.indirizzoDiStudio
                                                                ?.id ||
                                                            richiestaIscrizioneScolastica?.indirizzoDiStudio ||
                                                            ""
                                                        }
                                                        inputErrors={inputErrors}
                                                        required={
                                                            richiestaIscrizioneScolastica?.ordineGrado !==
                                                            "MEDIA"
                                                        }
                                                        disabled={
                                                            !richiestaIscrizioneScolastica.ordineGrado ||
                                                            !richiestaIscrizioneScolastica?.scuola
                                                        }
                                                        hidden={
                                                            richiestaIscrizioneScolastica?.ordineGrado ===
                                                            "MEDIA"
                                                        }
                                                    />
                                                </div>
                                            </>
                                        )}

                                    {!(
                                        richiestaIscrizioneScolastica.condizioneStudente ===
                                        "SOSPENSIONE_DEL_GIUDIZIO" ||
                                        richiestaIscrizioneScolastica.condizioneStudente ===
                                        "MOBILITA_FORMATIVA" ||
                                        richiestaIscrizioneScolastica.condizioneStudente ===
                                        "STATO_PROVVISORIO" ||
                                        richiestaIscrizioneScolastica.condizioneStudente ===
                                        "ATTESA_ASSEGNAZIONE"
                                    ) &&
                                        richiestaIscrizioneScolastica.istitutoInToscana ===
                                        false && (
                                            <>
                                                <div className="rtds-field-row">
                                                    <Select
                                                        classDiv={"rtds-mt-3 lg:rtds-mt-0"}
                                                        label={"Regione della scuola"}
                                                        id={"regioneScuolaFuoriToscana"}
                                                        classSelect={""}
                                                        onChange={(event) => onChangeRegione(event)}
                                                        baseOption={"Nessuna selezione"}
                                                        options={regioni}
                                                        bindValue={"value"}
                                                        bindKey={"key"}
                                                        value={
                                                            richiestaIscrizioneScolastica.regioneScuolaFuoriToscana ||
                                                            ""
                                                        }
                                                        inputErrors={inputErrors}
                                                        required
                                                    />

                                                    <Select
                                                        classDiv={"rtds-mt-3 lg:rtds-mt-0"}
                                                        label={"Comune della scuola"}
                                                        id={"comuneScuolaFuoriToscana"}
                                                        classSelect={""}
                                                        onChange={(event) =>
                                                            onChangeValue(
                                                                event,
                                                                "value",
                                                                "comuneFuoriToscanaId",
                                                            )
                                                        }
                                                        baseOption={"Nessuna selezione"}
                                                        bindKey={"id"}
                                                        bindValue={"denominazione"}
                                                        options={comuni}
                                                        value={
                                                            richiestaIscrizioneScolastica.comuneFuoriToscanaId ||
                                                            ""
                                                        }
                                                        inputErrors={inputErrors}
                                                        required={
                                                            !!richiestaIscrizioneScolastica.regioneScuolaFuoriToscana
                                                        }
                                                        disabled={
                                                            !richiestaIscrizioneScolastica.regioneScuolaFuoriToscana
                                                        }
                                                    />
                                                </div>

                                                <div className="rtds-field-row">
                                                    <Input
                                                        classDiv={"rtds-mt-3 lg:rtds-mt-0"}
                                                        label={"Codice meccanografico della scuola"}
                                                        id={"codiceScuolaFuoriToscana"}
                                                        classInput={"rtds-text-sm rtds-input-placeholder"}
                                                        type={"text"}
                                                        onChange={(event) =>
                                                            onChangeValue(
                                                                event,
                                                                "value",
                                                                "codiceScuolaFuoriToscana",
                                                            )
                                                        }
                                                        value={
                                                            richiestaIscrizioneScolastica.codiceScuolaFuoriToscana ||
                                                            ""
                                                        }
                                                        inputErrors={inputErrors}
                                                        required
                                                        maxLength={10}
                                                        minLength={10}
                                                    />
                                                    <Input
                                                        classDiv={"rtds-mt-3 lg:rtds-mt-0"}
                                                        label={"Denominazione della scuola"}
                                                        id={"denominazioneScuolaFuoriToscana"}
                                                        classInput={"rtds-text-sm rtds-input-placeholder"}
                                                        type={"text"}
                                                        onChange={(event) =>
                                                            onChangeValue(
                                                                event,
                                                                "value",
                                                                "denominazioneScuolaFuoriToscana",
                                                            )
                                                        }
                                                        value={
                                                            richiestaIscrizioneScolastica.denominazioneScuolaFuoriToscana ||
                                                            ""
                                                        }
                                                        inputErrors={inputErrors}
                                                        required
                                                        maxLength={255}
                                                    />
                                                    <Input
                                                        classDiv={"rtds-mt-3 lg:rtds-mt-0"}
                                                        label={"Indirizzo della scuola"}
                                                        id={"indirizzoScuolaFuoriToscana"}
                                                        classInput={"rtds-text-sm rtds-input-placeholder"}
                                                        type={"text"}
                                                        onChange={(event) =>
                                                            onChangeValue(
                                                                event,
                                                                "value",
                                                                "indirizzoScuolaFuoriToscana",
                                                            )
                                                        }
                                                        value={
                                                            richiestaIscrizioneScolastica.indirizzoScuolaFuoriToscana ||
                                                            ""
                                                        }
                                                        inputErrors={inputErrors}
                                                        required
                                                        maxLength={255}
                                                    />
                                                </div>
                                            </>
                                        )}

                                    {(richiestaIscrizioneScolastica.condizioneStudente ===
                                        "SOSPENSIONE_DEL_GIUDIZIO" ||
                                        richiestaIscrizioneScolastica.condizioneStudente ===
                                        "MOBILITA_FORMATIVA" ||
                                        richiestaIscrizioneScolastica.condizioneStudente ===
                                        "STATO_PROVVISORIO" ||
                                        richiestaIscrizioneScolastica.condizioneStudente ===
                                        "ATTESA_ASSEGNAZIONE") && (

                                            <Checkbox
                                                classDiv={'rtds-input-checkbox rtds-input--lg'}
                                                id={'confermaComunicazioneAssegnazione'}
                                                label={getInfoCondizioneStudente(richiestaIscrizioneScolastica.condizioneStudente)}
                                                inputErrors={inputErrors}
                                                classInput={''}
                                                onChange={(event) => { onChangeConfermaAssegnazione(event.target.checked); }}
                                                checked={richiestaIscrizioneScolastica?.confermaComunicazioneAssegnazione || false}
                                                required
                                            />
                                        )}



                                    <div className="rtds-horizontal-divider rtds-border-b rtds-border-gray-03 rtds-mt-3 rtds-mb-4 "></div>
                                    <div id="divIsee" hidden={!richiesta?.hasErroreIseeBase}>


                                        <h2 className="rtds-text-xl rtds-font-bold">ISEE</h2>
                                        <p>
                                            Inserire di seguito il numero di protocollo della DSU
                                            (Dichiarazione Sostitutiva Unica) presentata a INPS per
                                            l’attestazione ISEE dello studente beneficiario o del nucleo
                                            famigliare a cui appartiene (dove trovare il{" "}
                                            <a
                                                href={protocolloDsu}
                                                className="rtds-action-link
                rtds-action-link--has-icon"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                numero di protocollo DSU?
                                                <svg
                                                    className="rtds-icon rtds-fill-current rtds-h-6 rtds-w-6"
                                                    aria-hidden="true"
                                                    focusable="false"
                                                    role="img"
                                                >
                                                    <use
                                                        xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#mini--arrow-small-right`}
                                                    />
                                                </svg>
                                            </a>
                                            ).
                                        </p>
                                        <div className="rtds-field-row">
                                            <div className="rtds-input-field rtds-gap-1 ">
                                                <label className="rtds-input-field__label" htmlFor="dsu">
                                                    Numero di protocollo della DSU&nbsp;
                                                    <abbr
                                                        className="rtds-font-bold rtds-no-underline"
                                                        title="obbligatorio"
                                                    >
                                                        *
                                                    </abbr>
                                                </label>
                                                <div
                                                    className={`rtds-input rtds-background-04 rtds-rounded-lg ${showError && errorDsu ? "has-error" : ""
                                                        }`}
                                                >
                                                    <span
                                                        className="rtds-px-3 rtds-content-center rtds-content-03 rtds-whitespace-nowrap"
                                                        style={{ height: "var(--spacing-11)" }}
                                                    >
                                                        {inpsIseeCurrentYear}
                                                    </span>
                                                    <IMaskInput
                                                        mask="00000000A-00"
                                                        value={dsu}
                                                        onAccept={handleDsuChange}
                                                        definitions={{
                                                            A: /[A-Za-z]/,
                                                        }}
                                                        overwrite
                                                        id="dsu"
                                                        className="rtds-text-sm rtds-input-placeholder rtds-pr-12"
                                                        inputRef={dsuInputRef}
                                                    />

                                                    <svg
                                                        className="rtds-icon rtds-fill-current rtds-w-6 rtds-h-6 rtds-absolute rtds-right-4 rtds-content-placeholder rtds-content-error"
                                                        aria-hidden="true"
                                                        focusable="false"
                                                        role="img"
                                                        hidden={!showError || !errorDsu}
                                                    >
                                                        <use
                                                            xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#outline--exclamation-circle`}
                                                        />
                                                    </svg>
                                                </div>
                                                <span
                                                    hidden={!showError || !errorDsu}
                                                    className="rtds-input-field__error"
                                                >
                                                    DSU non valido
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>





                                {                                    
                                    <>
                                        <div className="rtds-horizontal-divider rtds-border-b rtds-border-gray-03 rtds-mt-3 rtds-mb-4 "></div>

                                        <h2 className="rtds-text-xl rtds-font-bold">
                                            Dati di pagamento
                                        </h2>
                                        <p>
                                            Indicare il codice IBAN del conto su cui si desidera ricevere il
            contributo che verrà assegnato se la domanda sarà ritenuta ammissibile al contributo.{" "}
                                        </p>
                                        <AlertMessage
                                            message="L’IBAN deve essere intestato, o cointestato, al soggetto richiedente che sta presentando la domanda. Si ricorda che il libretto postale non è accettato come opzione di pagamento."
                                            iconName="mini--information-circle"
                                            title="Attenzione!"
                                            classArticle="rtds-mb-6"
                                        />
                                        <div className={`rtds-field-row relative`}>
                                            <InputIban
                                                label={"IBAN"}
                                                id={"iban"}
                                                classInput={
                                                    "rtds-text-sm rtds-input-placeholder rtds-uppercase"
                                                }
                                                type={"text"}
                                                onChange={validazioneIBANItaliano}
                                                value={richiestaDatiPagamento.iban || ""}
                                                required
                                                maxLength={27}
                                                minLength={27}
                                                classDiv={`${!showError || !errorIban ? '' : 'has-error'}`}
                                                errorIban={showError && errorIban}
                                                errorMessage={"Iban non valido"}
                                                disabled={!richiesta.canBeUpdated}
                                            />

                                            <Input
                                                label={"Nome banca"}
                                                id={"denominazione"}
                                                inputErrors={inputErrors}
                                                classInput={"rtds-text-sm rtds-input-placeholder"}
                                                type={"text"}
                                                onChange={(event) => onChangeValue(event, "value", "denominazioneBanca")}
                                                value={richiestaDatiPagamento.denominazioneBanca || ""}
                                                required
                                                maxLength={255}
                                                disabled={!richiesta.canBeUpdated}
                                            />
                                        </div>

                                        <span hidden={!showError || !errorIban} className="rtds-input-field__error">Iban non valido</span>
                                    </>
                                }

                                

                                <div className="rtds-horizontal-divider rtds-border-b rtds-border-gray-03 rtds-mt-3 rtds-mb-4 "></div>

                                <div className="rtds-mb-6">
                                    <fieldset className="rtds-input-field rtds-gap-2">
                                        <legend className="rtds-input-field__label">
                                            {"Dichiaro: "}
                                        </legend>

                                        <Checkbox
                                            classDiv={"rtds-input-checkbox rtds-input--lg"}
                                            id={"informativa1"}
                                            classLabel={"rtds-mr-8"}
                                            label={
                                                "di essere consapevole che, nel caso di ottenimento del contributo, possono essere eseguiti controlli in applicazione dell'art. 4 comma 8 del D.Lgs. n. 109 del 31 marzo 1998, in materia di controllo della veridicità delle informazioni fornite; "
                                            }
                                            inputErrors={inputErrors}
                                            onChange={onChangeValueCheckBox}
                                            checked={
                                                informativa1 ||                                                
                                                false
                                            }
                                            required
                                            disabled={!richiesta?.canBeUpdated}
                                        />

                                        <Checkbox
                                            classDiv={"rtds-input-checkbox rtds-input--lg"}
                                            classLabel={"rtds-mr-8"}
                                            id={"informativa2"}
                                            label={
                                                "di essere consapevole delle sanzioni penali nel caso di dichiarazioni non veritiere, di formazione o uso di atti falsi, richiamate dall'art. 76 del D.P.R. 28.12.2000, n. 445;"
                                            }
                                            inputErrors={inputErrors}
                                            onChange={onChangeValueCheckBox}
                                            checked={
                                                informativa2 ||
                                                false
                                            }
                                            required
                                            disabled={!richiesta?.canBeUpdated}
                                        />
                                        <Checkbox
                                            classDiv={"rtds-input-checkbox rtds-input--lg"}
                                            classLabel={"rtds-mr-8"}
                                            id={"informativa3"}
                                            label={
                                                "di avere diritto al contributo in quanto esistono le condizioni di spettanza alla data di presentazione della domanda, impegnandosi a comunicare le eventuali successive variazioni secondo la procedura esposta nell'Avviso Libri Gratis, di cui si invita a prendere attenta e completa visione."
                                            }
                                            inputErrors={inputErrors}
                                            onChange={onChangeValueCheckBox}
                                            checked={
                                                informativa3 ||
                                                false
                                            }
                                            required
                                            disabled={!richiesta?.canBeUpdated}
                                        />
                                    </fieldset>                                    
                                </div>

                                <div                                    
                                    className="rtds-mb-6"
                                >
                                    <AlertMessage
                                        title="Attenzione!"
                                        message="Verificare tutti i dati inseriti prima di aggiornare la domanda."
                                        classDiv={""}
                                        classArticle={""}
                                        iconName={"mini--information-circle"}
                                    />
                                </div>

                                <div
                                    className="rtds-border-gray-02 rtds-border-b rtds-border-t rtds-p-3 rtds-flex sm:justify-end justify-center"
                                /*hidden={
                                  richiesta?.statoRichiesta !== "BOZZA" ||
                                  !richiesta?.canBeSaved
                                }*/
                                >
                                    <div className="rtds-form-actions">
                                        <div
                                            className="rtds-inline-flex rtds-gap-1"
                                            role="group"
                                            aria-label="Ruolo"
                                        >
                                            <button
                                                type="button"
                                                className="rtds-btn rtds-btn--primary rtds-form-submit rtds-btn--icon-right rtds-group/button"
                                                disabled={!richiesta.canBeUpdated || inSave}
                                                aria-busy={inSave}
                                                onClick={presentaDomanda}
                                            >
                                                {"Rettifica domanda"}

                                                {inSave ? (
                                                    <>
                                                        <svg
                                                            className="rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 rtds-animate-spin md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6"
                                                            aria-hidden="true"
                                                            focusable="false"
                                                            role="img"
                                                        >
                                                            <use
                                                                xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#spinner`}
                                                            />
                                                        </svg>
                                                        <span className="rtds-sr-only">Caricamento...</span>
                                                    </>
                                                ) : (
                                                    <>
                                                        <svg
                                                            className="rtds-icon rtds-fill-current rtds-w-4 rtds-h-4 md:rtds-w-5 md:rtds-h-5 lg:rtds-w-6 lg:rtds-h-6 group-hover/button:rtds-translate-x-1"
                                                            aria-hidden="true"
                                                            focusable="false"
                                                            role="img"
                                                        >
                                                            <use
                                                                xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#mini--chevron-right`}
                                                            />
                                                        </svg>
                                                    </>
                                                )}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <Modal
                    isOpen={isModalOpen}
                    title={title}
                    content={content}
                    onAction={handleModalAction}
                    actionLabel={actionLabel}
                    closeLabel="Annulla"
                    hideCloseButton={hideCloseButton}
                    icona={icon}
                    iconaClass={iconaClass}
                    iconaColorClass={iconaColorClass}
                    onClose={() => setModalOpen(false)}

                //disabledConfirmBtn={inSave}
                //disableCloseBtn={inSave}
                />
            </div>
        </>
    );
};

export default RettificaRipresentazione;
